<template>
  <!-- Service Section -->
  <section class="service-section featured-saloons">
    <div class="container">
    <div class="services-header aos" data-aos="fade-up">
      <div class="row">
        <div class="col-md-12">
          <div class="section-content">
            <h2>Featured Saloons</h2>
            <div class="our-img-all-1">
              <img src="@/assets/img/icons/cuttor-small.svg" alt="Scissor">
            </div>
            <p>Our Barbershop & Tattoo Salon provides classic services combined with innovative
              techniques.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-md-6 col-sm-6 col-12 d-flex">
        <div class="card flex-fill aos" data-aos="fade-right">
          <div class="card-body">
            <div class="service-widget">
              <div class="service-img service-show-img">
                <router-link to="/details/service-details">
                  <img class="img-fluid serv-img" alt="Service Image"
                    src="@/assets/img/services/service-b-01.jpg">
                </router-link>
                <div class="item-info item-infos">
                  <div class="rating">
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                  </div>
                </div>
              </div>
              <div class="service-content service-content-three">
                <h3 class="title">
                  <router-link to="/details/service-details">Saloon 24 Hair Designers</router-link>
                </h3>
                <ul>
                  <li>Deep Pore Cleansing</li>
                  <li>Straight Razor Shave</li>
                </ul>
                <div class="main-saloons-profile">
                  <div class="saloon-profile-left">
                    <router-link to="/service-provider/provider-details" class="saloon-img">
                      <img src="@/assets/img/profiles/avatar-20.jpg" alt="User">
                    </router-link>
                    <div class="saloon-content">
                      <div class="saloon-content-top mb-1">
                        <i class="feather-clock"></i>
                        <span>07:00 AM - 11:00 PM </span>
                      </div>
                      <div class="saloon-content-btn">
                        <span><i class="feather-map-pin"></i></span>
                        <span>Main Boulevard, Lahore,</span>
                      </div>
                    </div>
                  </div>
                  <div class="saloon-right">
                    <span>$70</span>
                  </div>
                </div>
                <div class="saloon-bottom">
                  <router-link to="/details/service-details" class="btn btn-dark"><i
                      class="feather-calendar me-2"></i>Book Appointment</router-link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-xl-4 col-md-6 col-sm-6 col-12 d-flex">
        <div class="card flex-fill aos" data-aos="fade-up">
          <div class="card-body">
            <div class="service-widget">
              <div class="service-img service-show-img">
                <router-link to="/details/service-details">
                  <img class="img-fluid serv-img" alt="Service Image"
                    src="@/assets/img/services/service-b-02.jpg">
                </router-link>
                <div class="item-info item-infos">
                  <div class="rating">
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                  </div>
                </div>
              </div>
              <div class="service-content service-content-three">
                <h3 class="title">
                  <router-link to="/details/service-details">The Rockstar Barber</router-link>
                </h3>
                <ul>
                  <li>Buzz Cut</li>
                  <li>Blowout</li>
                </ul>
                <div class="main-saloons-profile">
                  <div class="saloon-profile-left">
                    <router-link to="/service-provider/provider-details" class="saloon-img">
                      <img src="@/assets/img/profiles/avatar-19.jpg" alt="User">
                    </router-link>
                    <div class="saloon-content">
                      <div class="saloon-content-top mb-1">
                        <i class="feather-clock"></i>
                        <span>09:00 AM - 05:00 PM </span>
                      </div>
                      <div class="saloon-content-btn">
                        <i class="feather-map-pin"></i>
                        <span>30 Small Street, Newyork</span>
                      </div>
                    </div>
                  </div>
                  <div class="saloon-right">
                    <span>$50</span>
                  </div>
                </div>
                <div class="saloon-bottom">
                  <router-link to="/details/service-details" class="btn btn-dark"><i
                      class="feather-calendar me-2"></i>Book Appointment</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 col-sm-6 col-12 d-flex">
        <div class="card flex-fill aos" data-aos="fade-left">
          <div class="card-body">
            <div class="service-widget">
              <div class="service-img service-show-img">
                <router-link to="/details/service-details">
                  <img class="img-fluid serv-img" alt="Service Image"
                    src="@/assets/img/services/service-b-03.jpg">
                </router-link>
                <div class="item-info item-infos">
                  <div class="rating">
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                  </div>
                </div>
              </div>
              <div class="service-content service-content-three">
                <h3 class="title">
                  <router-link to="/details/service-details">Femina Hairstyle</router-link>
                </h3>
                <ul>
                  <li>Pore Cleansing</li>
                  <li>Hair Style Menicure</li>
                </ul>
                <div class="main-saloons-profile">
                  <div class="saloon-profile-left">
                    <router-link to="/service-provider/provider-details" class="saloon-img">
                      <img src="@/assets/img/profiles/avatar-18.jpg" alt="User">
                    </router-link>
                    <div class="saloon-content">
                      <div class="saloon-content-top mb-1">
                        <i class="feather-clock"></i>
                        <span>09:00 AM - 07:00 PM </span>
                      </div>
                      <div class="saloon-content-btn">
                        <i class="feather-map-pin"></i>
                        <span>Bungalow, Omaha</span>
                      </div>
                    </div>
                  </div>
                  <div class="saloon-right">
                    <span>$40</span>
                  </div>
                </div>
                <div class="saloon-bottom">
                  <router-link to="/details/service-details" class="btn btn-dark"><i
                      class="feather-calendar me-2"></i>Book Appointment</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 col-sm-6 col-12 d-flex">
        <div class="card flex-fill  aos" data-aos="fade-right">
          <div class="card-body">
            <div class="service-widget">
              <div class="service-img service-show-img">
                <router-link to="/details/service-details">
                  <img class="img-fluid serv-img" alt="Service Image"
                    src="@/assets/img/services/service-b-04.jpg">
                </router-link>
                <div class="item-info item-infos">
                  <div class="rating">
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                  </div>
                </div>
              </div>
              <div class="service-content service-content-three">
                <h3 class="title">
                  <router-link to="/details/service-details">Master Barber</router-link>
                </h3>
                <ul>
                  <li>Hair Cut</li>
                  <li>Hair Styling</li>

                </ul>
                <div class="main-saloons-profile">
                  <div class="saloon-profile-left">
                    <router-link to="/service-provider/provider-details" class="saloon-img">
                      <img src="@/assets/img/profiles/avatar-17.jpg" alt="User">
                    </router-link>
                    <div class="saloon-content">
                      <div class="saloon-content-top mb-1">
                        <i class="feather-clock"></i>
                        <span>08:00 AM - 05:00 PM </span>
                      </div>
                      <div class="saloon-content-btn">
                        <i class="feather-map-pin"></i>
                        <span>Villa Drive, South</span>
                      </div>
                    </div>
                  </div>
                  <div class="saloon-right">
                    <span>$36</span>
                  </div>
                </div>
                <div class="saloon-bottom">
                  <router-link to="/details/service-details" class="btn btn-dark"><i
                      class="feather-calendar me-2"></i>Book Appointment</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 col-sm-6 col-12 d-flex ">
        <div class="card flex-fill aos" data-aos="fade-up">
          <div class="card-body">
            <div class="service-widget">
              <div class="service-img service-show-img">
                <div class="service-img-top">
                  <router-link to="/details/service-details">
                    <img class="img-fluid serv-img" alt="Service Image"
                      src="@/assets/img/services/service-b-05.jpg">
                  </router-link>
                </div>
                <div class="item-info item-infos">
                  <div class="rating">
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                  </div>
                </div>
              </div>
              <div class="service-content service-content-three">
                <h3 class="title">
                  <router-link to="/details/service-details">Cut & Colors Hair Dressers</router-link>
                </h3>
                <ul>
                  <li>Face Cleaning</li>
                  <li>Clean Shaving</li>
                </ul>
                <div class="main-saloons-profile">
                  <div class="saloon-profile-left">
                    <router-link to="/service-provider/provider-details" class="saloon-img">
                      <img src="@/assets/img/profiles/avatar-15.jpg" alt="User">
                    </router-link>
                    <div class="saloon-content">
                      <div class="saloon-content-top mb-1">
                        <i class="feather-clock"></i>
                        <span>09:00 AM - 06:00 PM </span>
                      </div>
                      <div class="saloon-content-btn">
                        <i class="feather-map-pin"></i>
                        <span>Sarah Drive, Lafayette</span>
                      </div>
                    </div>
                  </div>
                  <div class="saloon-right">
                    <span>$42</span>
                  </div>
                </div>
                <div class="saloon-bottom">
                  <router-link to="/details/service-details" class="btn btn-dark"><i
                      class="feather-calendar me-2"></i>Book Appointment</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 col-sm-6 col-12 d-flex">
        <div class="card flex-fill aos" data-aos="fade-left">
          <div class="card-body">
            <div class="service-widget">
              <div class="service-img service-show-img">
                <router-link to="/details/service-details">
                  <img class="img-fluid serv-img" alt="Service Image"
                    src="@/assets/img/services/service-b-06.jpg">
                </router-link>
                <div class="item-info item-infos">
                  <div class="rating">
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                    <i class="fas fa-star filled me-1"></i>
                  </div>
                </div>
              </div>
              <div class="service-content service-content-three">
                <h3 class="title">
                  <a href="#">Rearhair Stylist</a>
                </h3>
                <ul>
                  <li>Face Cleaning</li>
                  <li>Hair Styling</li>
                </ul>
                <div class="main-saloons-profile">
                  <div class="saloon-profile-left">
                    <router-link to="/service-provider/provider-details" class="saloon-img">
                      <img src="@/assets/img/profiles/avatar-20.jpg" alt="User">
                    </router-link>
                    <div class="saloon-content">
                      <div class="saloon-content-top mb-1">
                        <i class="feather-clock"></i>
                        <span>09:00 AM - 11:00 PM </span>
                      </div>
                      <div class="saloon-content-btn">
                        <i class="feather-map-pin"></i>
                        <span>Nash Street, Southfield</span>
                      </div>
                    </div>
                  </div>
                  <div class="saloon-right">
                    <span>$70</span>
                  </div>
                </div>
                <div class="saloon-bottom">
                  <router-link to="/details/service-details" class="btn btn-dark"><i
                      class="feather-calendar me-2"></i>Book Appointment</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </section>
  <!-- /Service Section -->

  <!-- Appointment Section -->
  <section class="appointment-section appointment-section-four aos" data-aos="fade-up">
    <div class="index-4">
      <img src="@/assets/img/icons/saloon-bg.svg" class="img-fluid h-100 w-100" alt="bg">
    </div>
    <div class="container">
      <div class="appointment-main">
        <a href="#" class="btn btn-secondary text-white">GET A MODERN LOOK</a>
        <h2>Upto 25% offer on First Appointment</h2>
        <p class="text-center">Each service provider will have a listing that typically includes a
          description of their services, pricing, availability, and any special offers or packages.
        </p>
        <div class="appointment-btn">
          <router-link to="/free-trail" class="btn btn-primary p-3">BOOK AN APPOINTMENT NOW</router-link>
        </div>
      </div>
    </div>
		</section>
  <!-- /Appointment Section -->
</template>
